import * as React from 'react';
import { StrictMode } from 'react';
import { Provider } from 'react-redux';
import { ErrorLogComponent } from '@cian/error-log-component';
import { UiKitContextProvider } from '@cian/ui-kit/context';
import { uaToDeviceType } from '@cian/ui-kit/utils';
import { Provider as MicrofrontendProvider } from '@cian/mf-react';

import { ServicePickerWidget } from '../../../ServicePickerWidget';
import { PayPackageMicrofrontend } from '../../../PayPackageMicrofrontend';
import { PaymentWidgetMicrofrontend } from '../../../PaymentWidgetMicrofrontend';

import { IAppInitialContext, IAppContext, TReduxStore } from '../../types';
import { createAnalytics } from '../../services/analytics';

import { AppContext } from '../AppContext';

export interface IAppModulesWrapperProps {
  context: IAppInitialContext;
  reduxStore: TReduxStore;
}

/**
 * Не удалять!
 * В этот объект помещаются колбэки, которые вызывают мобильные приложения.
 * Таким образом обеспечивается передача данных mobile app → web app.
 */
if (process.env.IS_BROWSER_BUILD) {
  window.appInterfaceV2 = window.appInterfaceV2 || {};
}

export const AppModulesWrapper: React.FC<IAppModulesWrapperProps> = ({ reduxStore, context }) => {
  const {
    logger,
    custom: { userAgent },
    microfrontendsRegistry,
    isMicrofrontend,
    webview,
  } = context;

  const deviceType = uaToDeviceType(userAgent || undefined);

  const analytics = createAnalytics(reduxStore);
  const appContext: IAppContext = React.useMemo(() => ({ ...context, analytics }), [context, analytics]);

  React.useEffect(() => {
    // Вызов метода нужен для отправки события @@APP-INIT при старте
    // as any временный костыль, пока платформа не поправит интерфейс
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (webview as any).appInit?.();
  }, [webview]);

  return (
    <StrictMode>
      <ErrorLogComponent logger={logger}>
        <AppContext.Provider value={appContext}>
          <UiKitContextProvider deviceType={deviceType}>
            <Provider store={reduxStore}>
              <MicrofrontendProvider registry={microfrontendsRegistry}>
                <ServicePickerWidget />

                <PayPackageMicrofrontend />

                {isMicrofrontend && <PaymentWidgetMicrofrontend />}
              </MicrofrontendProvider>
            </Provider>
          </UiKitContextProvider>
        </AppContext.Provider>
      </ErrorLogComponent>
    </StrictMode>
  );
};
